<style>
#CheckGraphResults .v--modal-box.v--modal {
  min-height: 480px !important;
  min-width: 840px !important;
}
#CheckGraphResults * {
  font-size: 12px;
}
#CheckGraphResults .list--el--bold {
  font-weight: bold;
  color: rgba(0, 0, 0, 0.54);
}
#CheckGraphResults .v-icon.material-icons {
  font-size: 18px;
}
#CheckGraphResults .icons-container {
  display: flex;
  justify-content: space-between;
}
#CheckGraphResults
  div.v-menu__content.theme--light.menuable__content__active
  div {
  padding: 0px !important;
}
</style>

<template>
  <Modal
    modalName="CheckGraphResults"
    title="Wynik sprawdzania poprawności sieci"
    @closed="close"
    :buttons="['save']"
  >
    <v-container>
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <v-list>
            <!-- <v-list-tile class="list--el">
              <v-list-tile-title class="list--el--bold">Typ błędu</v-list-tile-title>
              <v-list-tile-title class="list--el--bold">ID obiektu / nazwa kolumny</v-list-tile-title>
            </v-list-tile>-->
            <template v-for="(val,key) in hydraulicObjects">
              <span v-if="val.length > 0 || Object.keys(val).length > 0">
                <v-list-tile
                  class="list--el"
                  :key="key"
                >
                  <v-list-tile-title class="list--el--bold">{{errorsMap[key]}}</v-list-tile-title>
                  <v-list-tile-title
                    class="list--el--bold"
                    v-if="key == 'no_start_node' || key == 'no_end_node' || key ==  'bad_start_node' || key == 'bad_end_node' || key == 'bad_start_node_type' || key == 'bad_end_node_type'"
                  >ID obiektu</v-list-tile-title>
                  <v-list-tile-title
                    class="list--el--bold"
                    v-if="key == 'no_parent_pipe'"
                  >
                    Lista przewodów wodociągowych
                    <v-icon title="Lista przewodów wodociągowych, które przecinają się z danym punktem, czyli potencjalne możliwości jakie mogą przyjąć atrybuty parent_pipe dla tych warstw">help</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-title
                    class="list--el--bold"
                    v-if="key == 'bad_parent_pipe'"
                  >Lista przewodów wodociągowych</v-list-tile-title>
                  <v-list-tile-title
                    class="list--el--bold"
                    v-if="key == 'duplicate_points'"
                  >
                    ID punktów
                    <v-icon title="ID punktów, które mają taką samą geometrię">help</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-title
                    class="list--el--bold"
                    v-if="key == 'no_attributes'"
                  >ID obiektu</v-list-tile-title>
                  <v-list-tile-title
                    class="list--el--bold"
                    v-if="key == 'no_attributes'"
                  >
                    Nazwa kolumny
                    <v-icon title="Nazwa kolumny, która nie ma wartości wymaganej do wykonania modelowania">help</v-icon>
                  </v-list-tile-title>
                </v-list-tile>
                <template v-if="Array.isArray(val)">
                  <template
                    v-for="el in val"
                    v-if="val.length > 0"
                  >
                    <v-list-tile class="list--el">
                      <v-list-tile-title>Przewody wodociągowe</v-list-tile-title>
                      <v-list-tile-title class="icons-container">
                        {{el}}
                        <span>
                          <v-icon
                            title="Pokaż na mapie"
                            @click="zoomToFeature(el, 'pipes')"
                          >zoom_in</v-icon>
                          <v-icon
                            title="Napraw"
                            @click="repairGraphElement(key, el, 'pipes')"
                          >build</v-icon>
                        </span>
                      </v-list-tile-title>
                    </v-list-tile>
                  </template>
                </template>
                <template v-else>
                  <!-- if it's object -->
                  <template v-for="(v, k) in val">
                    <v-list-tile
                      class="list--el"
                      v-if="key == 'duplicate_points' && v.length <= 1"
                    >
                      <v-list-tile-title>{{layersMap[k]}}</v-list-tile-title>
                      <v-list-tile-title class="icons-container">
                        {{v}}
                        <span>
                          <v-icon
                            title="Pokaż na mapie"
                            @click="zoomToFeature(v[0], k)"
                          >zoom_in</v-icon>
                          <v-icon
                            title="Napraw"
                            @click="repairGraphElement(key, v, k)"
                          >build</v-icon>
                        </span>
                      </v-list-tile-title>
                    </v-list-tile>
                    <template
                      v-for="valElement in v"
                      v-if="v.length > 1"
                    >
                      <v-list-tile class="list--el">
                        <v-list-tile-title>{{layersMap[k]}}</v-list-tile-title>
                        <v-list-tile-title class="icons-container">
                          {{valElement.join(', ')}}
                          <span>
                            <v-icon
                              title="Pokaż na mapie"
                              @click="zoomToFeature(valElement[0], k)"
                            >zoom_in</v-icon>
                            <v-icon
                              title="Napraw"
                              @click="repairGraphElement(key, valElement, k)"
                            >build</v-icon>
                          </span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </template>
                    <template
                      v-for="(valElement2val, valElement2key) in v"
                      v-if="key == 'no_parent_pipe' || key == 'bad_parent_pipe'"
                    >
                      <v-list-tile class="list--el">
                        <v-list-tile-title>{{layersMap[k]}}</v-list-tile-title>
                        <v-list-tile-title class="icons-container">
                          {{valElement2key}}
                          <span>
                            <v-icon
                              title="Pokaż na mapie"
                              @click="zoomToFeature(valElement2key, k)"
                            >zoom_in</v-icon>
                            <v-menu
                              bottom
                              left
                            >
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  title="Napraw"
                                  v-on="on"
                                >build</v-icon>
                              </template>

                              <v-list>
                                <v-list-tile>Wybierz przewód do przypisania</v-list-tile>
                                <v-list-tile
                                  v-for="el in valElement2val"
                                  :key="el"
                                  class="list--el"
                                >
                                  <v-list-tile-title @click="repairGraphElement(key, [el, valElement2key], k)">{{el}}</v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </template>
                    <template
                      v-for="(test,index) in v"
                      v-if="key == 'no_attributes'"
                    >
                      <v-list-tile
                        class="list--el"
                        v-if="Object.keys(v)[index]"
                      >
                        <v-list-tile-title>{{layersMap[k]}}</v-list-tile-title>
                        <v-list-tile-title>{{Object.keys(v)[index]}}</v-list-tile-title>
                        <v-list-tile-title
                          class="icons-container"
                          :title="Object.values(v)[index].join(', ')"
                        >
                          <span v-if="Object.values(v)[index].join(', ').length > 20">{{ Object.values(v)[index].join(', ').slice(0,30)}}...</span>
                          <span v-else>{{ Object.values(v)[index].join(', ') }}</span>
                          <span>
                            <v-icon
                              title="Pokaż na mapie"
                              @click="zoomToFeature(Object.keys(v)[index], k)"
                            >zoom_in</v-icon>
                            <v-icon
                              title="Napraw"
                              @click="showInfo"
                            >build</v-icon>
                          </span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </template>
                  </template>
                </template>
              </span>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-container>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    hydraulicObjects: [],
    errorsMap: {
      no_start_node: "Brak węzła początkowego",
      no_end_node: "Brak węzła końcowego",
      no_parent_pipe: "Brak rury nadrzędnej",
      bad_parent_pipe: "Błędny przypisany przewód wodociągowy",
      bad_start_node: "Błędny węzeł początkowy",
      bad_end_node: "Błędny węzeł końcowy",
      bad_start_node_type: "Błędny typ węzła początkowego",
      bad_end_node_type: "Błędny typ węzła końcowego",
      pumps_no_parent_pipe: "Pompa z nieokreślonym przewodem",
      valves_no_parent_pipe: "Armatura zaporowa z nieokreślonym przewodem",
      controls_no_parent_pipe: "Armatura regulacyjna z nieokreślonym przewodem",
      duplicate_points: "Zduplikowane obiekty w danym punkcie",
      no_attributes: "Brak wartości dla atrybutów"
    },
    layersMap: {
      controls: "Armatura regulacyjna",
      fittings: "Inne urządzania wodociągowe",
      valves: "Armatura zaporowa",
      hydrants: "Hydranty",
      chambers: "Komory wodociągowe",
      pumps: "Pompy",
      pipes: "Przewody wodociągowe",
      terminals: "Przyłącza wodociągowe",
      partitions: "Punkty rozbioru wody",
      manholes: "Studzienki wodociągowe",
      reservoirs: "Ujęcia wody",
      watermeters: "Wodomierze",
      junctions: "Węzły",
      locks: "Zasuwy na przyłączach",
      tanks: "Zbiorniki"
    },
    pipesFields: [
      "no_start_node",
      "no_end_node",
      "bad_start_node",
      "bad_end_node",
      "bad_start_node_type",
      "bad_end_node_type"
    ]
  }),
  computed: {
    layersInstance() {
      return this.$store.getters.getLayersInstance;
    }
  },
  methods: {
    showInfo() {
      this.$root.$emit(
        "showSnackbar",
        "orange",
        `Tego błędu nie można naprawić - wyedytuj obiekt`
      );
    },
    repairGraphElement(errorType, featureID, layer) {
      if(errorType == "bad_parent_pipe" || errorType == "no_parent_pipe") {
        let payload = {
          error: errorType,
          layer: layer,
          feature: featureID[1],
          pipe_id: featureID[0]
        };
        this.fixWaterModel(payload);
      } else {
        let payload = {
          error: errorType,
          feature: featureID
        };
        if(errorType == "duplicate_points") {
          payload["layer"] = layer;
          payload["feature"] = featureID[0][0];
          payload["to_delete"] = featureID[0];
        }
        this.fixWaterModel(payload);
      }
    },
    fixWaterModel(payload) {
      this.$store.dispatch("waterModelFix", payload).then(r => {
        if(r) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            `Pomyślnie dokonano naprawy`
          );
          this.$store.dispatch("checkGraph").then(r => {
            if(r.status == 200) {
              this.hydraulicObjects = r.data;
            } else {
              this.$root.$emit("showSnackbar", "red", `${r}`);
            }
          });
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    checkingGraphEnd(data) {
      this.hydraulicObjects = data;
    },
    zoomToFeature(featureId, layerName) {
      if(this.layersInstance[layerName].getVisible()) {
        this.$root.$emit("findFeatureById", featureId, layerName);
      } else {
        this.$root.$emit(
          "showSnackbar",
          "orange",
          "Włącz widoczność danej warstwy aby móc przybliżyć"
        );
      }
    },
    close() {
      this.hydraulicObjects = [];
      this.$modal.hide("CheckGraphResults");
    }
  },
  mounted() {
    this.$root.$on("checkingGraphEnd", this.checkingGraphEnd);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/CheckGraphResults.vue